import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const tagSabadell =(value, idiom) =>{
	//const { i18n } = useTranslation();

	const tealium_data = {
		pagina: {
			categoriaPagina: 'plataforma gibobs',
			idioma: idiom
		},
		prod: {
			categoriaProducto: 'financiacion',
			nivel1: 'particulares',
			nivel2: 'financiacion',
			nivel3: 'hipotecas',
			nivel4: 'portal usuario gibobs',
			nombreProducto: 'hipotecas',
			paso: value
		},

		operativa: {
			nombreOperativa: 'plataforma hipotecas',
			pasoOperativa: value
		},
		area: {
			canal: 'bancsabadell',
			entorno: 'bso.informacional'
		}
	};

	
		
	window.bsSend('view', tealium_data);
		
};

export default tagSabadell;


